import Vue from 'vue';
import Vuex from 'vuex';
import { parseUrlFilters } from 'utils/url';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import * as user from '../modules/user';
import * as generic from '../modules/generic';
import * as productComparison from '../modules/product-comparison';

Vue.use(Vuex);

const getDocumentWidth = () => document.documentElement.getBoundingClientRect().width;

const state = {
  results: {
    total: 0,
    hits: [],
    aggregations: {}
  },
  favorites: [],
  urlFilters: parseUrlFilters(),
  filterConfig: payload.filterConfig,
  activeDropDownFilter: null,
  isLoading: false,
  fieldManifest: payload.fieldManifest,
  mobileFilterBarVisible: false,
  basket: [],
  availableTabs: ['search', 'mysheets'],
  documentServiceClient: null,
  documentWidth: getDocumentWidth(),
  msdsSettings: undefined,
};

window.addEventListener('resize', () => {
  state.documentWidth = getDocumentWidth();
}, false);

const store = new Vuex.Store({
  modules: {
    user,
    generic,
    productComparison
  },
  state,
  getters,
  actions,
  mutations
});

user.init(store);
generic.init(store);

// Disable the product comparison basket
store.dispatch('productComparison/disableBasket');

export default store;
